import { Star } from "lucide-react";
import { MARQUEE_ITEMS } from "@/content/siteContent";

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-white/10 bg-navy-900 py-5" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {MARQUEE_ITEMS.map((item) => (
              <span key={`${half}-${item}`} className="flex items-center">
                <span className="text-outline px-8 font-display text-2xl font-bold uppercase tracking-wider sm:text-4xl">
                  {item}
                </span>
                <Star className="h-4 w-4 shrink-0 text-gold/60" fill="currentColor" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
